// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "trix"
import "trix/dist/trix.css"
import "leaflet/dist/leaflet.css"
import "./controllers"

// Turbo bytter <body> ud og lader <html> stå som den var. Det er et problem
// her, fordi hele administrationsmodulets udseende hænger på klassen
// `admin-ui` på netop <html>: over hundrede regler er scopet til den.
//
// Uden det her mister man stilarket, hver gang man krydser grænsen mellem det
// offentlige site og administrationen — typisk lige efter login, hvor siden
// kommer op med overskrifter i den forkerte skrift og kort uden rammer — og
// omvendt tager man `admin-ui` med ud på den offentlige side, når man logger
// ud. Begge dele forsvinder ved en almindelig genindlæsning, hvilket er
// præcis derfor det er svært at få øje på.
//
// Klassen kopieres fra det dokument, Turbo er ved at tegne, frem for at blive
// regnet ud her. Så er der ét sted, der bestemmer den: layoutet.
document.addEventListener("turbo:before-render", (event) => {
  const incoming = event.detail.newBody?.parentElement

  if (incoming) document.documentElement.className = incoming.className
})
